<ng-container *transloco="let t">
  <app-race-commercial-item-card [event]="event" [race]="race" [eventPaymentSettings]="eventPaymentSettings"
    [organiserPaymentData]="organiserPaymentData" [disableEditing]="disableEditing" [registrationFeeTypes]="registrationFeeTypes"
    (raceCommercialItemsChanged)="onRaceCommercialItemsChanged($event)"
    [raceCommercialItems]="raceCommercialItems" [currencies]="currencies" [languages]="languages"/>
  <app-race-additional-pricing-item-card [event]="event" [race]="race" [eventPaymentSettings]="eventPaymentSettings"
                                         [languages]="languages"
    (raceAdditionalItemsChanged)="onRaceAdditionalItemsChanged($event)" [organiserPaymentData]="organiserPaymentData"
    [raceAdditionalItems]="raceAdditionalItems" [disableEditing]="disableEditing" [currencies]="currencies" [displayFlags]="displayFlags" [visibilityTypes]="visibilityTypes"/>
  <app-action-buttons-row [saveVisible]="false"/>
</ng-container>
